module.exports = __webpack_public_path__ + "static/media/Springer-Logo.dc85cc40.jpg";